import React from 'react';
import { StickyBar } from '../components/StickyBar';
import { HeroSection } from '../components/HeroSection';
import { MirrorReality } from '../components/MirrorReality';
import { CortisolReveal } from '../components/CortisolReveal';
import { OfferStack } from '../components/OfferStack';
import { PreBabyJeans } from '../components/PreBabyJeans';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { SocialProofToast } from '../components/SocialProofToast';
import { TextTestimonial } from '../components/TextTestimonial';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-body text-brand-charcoal selection:bg-brand-sage/30 relative pb-24 md:pb-0" data-id="element-195">
      <StickyBar data-id="element-196" />
      <main data-id="element-197">
        <HeroSection data-id="element-198" />

        {/* Testimonial 1: The Busy Executive Mom */}
        <div className="bg-brand-cream/30 border-y border-brand-cream" data-id="element-199">
          <TextTestimonial author="Emily R." location="Austin, TX" data-id="element-200">
            I was terrified I'd never recognize my own body again, but I have
            ZERO time for hour-long gym sessions. The 15-minute daily protocols
            in the Blueprint were my saving grace. I'm 4 weeks in, my core feels
            stronger than ever, and I finally have the energy to keep up with my
            toddler and my Zoom calls.{' '}
            <strong className="font-bold" data-id="element-201">
              Best investment I've ever made for myself.
            </strong>
          </TextTestimonial>
        </div>

        <MirrorReality data-id="element-202" />
        <CortisolReveal data-id="element-203" />
        <OfferStack data-id="element-204" />
        <PreBabyJeans data-id="element-205" />

        {/* Pre-Pricing Testimonials */}
        <div className="bg-white py-12 border-t border-brand-cream" data-id="element-206">
          <div className="max-w-4xl mx-auto px-4 text-center mb-4" data-id="element-207">
            <p className="text-brand-sage font-bold tracking-widest uppercase text-sm" data-id="element-208">
              Real Moms. Real Restoration.
            </p>
          </div>

          {/* Testimonial 2: Identity & Mental Health */}
          <TextTestimonial author="Jessica M." location="San Diego, CA" data-id="element-209">
            Most programs just focus on the 'bounce back' and it's so toxic. The
            Snap-Back Blueprint is different. It's about restoration, not just
            weight. It helped me reclaim my sense of self when I felt like I was
            disappearing into diaper changes and sleepless nights. I feel
            radiant, balanced, and—for the first time—
            <strong className="font-bold" data-id="element-210">like MYSELF again.</strong>
          </TextTestimonial>

          {/* Testimonial 3: The Price Skeptic */}
          <div className="mt-8 border-t border-brand-cream/50 pt-8" data-id="element-211">
            <TextTestimonial author="Ashley K." location="Miami, FL" result="Dropped 2 dress sizes without crashing my metabolism." data-id="element-212">
              Honestly? I thought for $6 this would be a cheap 2-page PDF. I was
              wrong. This is a high-end system. The biology-backed science
              actually makes sense, and the results were almost instant. I've
              paid $200 for trainers who didn't give me half the clarity this
              Blueprint offers. If you're on the fence, just do it.{' '}
              <strong className="font-bold" data-id="element-213">
                Your future self will thank you.
              </strong>
            </TextTestimonial>
          </div>
        </div>

        <PricingSection data-id="element-214" />
      </main>
      <Footer data-id="element-215" />
      <SocialProofToast data-id="element-216" />
    </div>;
}